import { Route, Switch } from "react-router";
import { AppRouteUi } from "../../../config/appRoute";
import { RedirectRoute } from "../../../components/redirectRoute";
import { PageInvoiceList } from "./pageInvoiceList";
import { PageInvoiceEdit } from "./pageInvoiceEdit";
import { PageSingleInvoice } from "./pageSingleInvoice";

export function PageInvoice(): JSX.Element {
  return (
    <div className="">
      <Switch>
        <Route
          path={AppRouteUi.Invoice.List()}
          exact
          component={PageInvoiceList}
        />
        <Route
          path={AppRouteUi.Invoice.Edit()}
          exact
          component={PageInvoiceEdit}
        />
        <Route
          path={AppRouteUi.Invoice.ById()}
          exact
          component={PageSingleInvoice}
        />
        <RedirectRoute
          from={AppRouteUi.Invoice.Root()}
          to={AppRouteUi.Invoice.List()}
          wildcardOpt={{
            defaultTo404Page: true,
          }}
        />
      </Switch>
    </div>
  );
}
